/* tslint:disable */
/* eslint-disable */
/**
 * Actors API
 * API for managing actors, including legal and physical persons.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Financial data of the parent legal entity for a fiscal year. Updates the line of that fiscal year if it exists, otherwise creates it.
 * @export
 * @interface UpdateLegalEntityFinancialsCommandDto
 */
export interface UpdateLegalEntityFinancialsCommandDto {
    /**
     * Revenue of the fiscal year, in euros
     * @type {number}
     * @memberof UpdateLegalEntityFinancialsCommandDto
     */
    revenue: number;
    /**
     * Number of employees
     * @type {number}
     * @memberof UpdateLegalEntityFinancialsCommandDto
     */
    employeesCount: number;
    /**
     * Date calendaire "yyyy-MM-dd". L\'heure est ignorée par le back, aucune conversion de fuseau n\'est appliquée.
     * @type {string}
     * @memberof UpdateLegalEntityFinancialsCommandDto
     */
    fiscalYearEnd: string;
}

/**
 * Check if a given object implements the UpdateLegalEntityFinancialsCommandDto interface.
 */
export function instanceOfUpdateLegalEntityFinancialsCommandDto(value: object): value is UpdateLegalEntityFinancialsCommandDto {
    if (!('revenue' in value) || value['revenue'] === undefined) return false;
    if (!('employeesCount' in value) || value['employeesCount'] === undefined) return false;
    if (!('fiscalYearEnd' in value) || value['fiscalYearEnd'] === undefined) return false;
    return true;
}

export function UpdateLegalEntityFinancialsCommandDtoFromJSON(json: any): UpdateLegalEntityFinancialsCommandDto {
    return UpdateLegalEntityFinancialsCommandDtoFromJSONTyped(json, false);
}

export function UpdateLegalEntityFinancialsCommandDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLegalEntityFinancialsCommandDto {
    if (json == null) {
        return json;
    }
    return {
        
        'revenue': json['revenue'],
        'employeesCount': json['employeesCount'],
        'fiscalYearEnd': json['fiscalYearEnd'],
    };
}

export function UpdateLegalEntityFinancialsCommandDtoToJSON(json: any): UpdateLegalEntityFinancialsCommandDto {
    return UpdateLegalEntityFinancialsCommandDtoToJSONTyped(json, false);
}

export function UpdateLegalEntityFinancialsCommandDtoToJSONTyped(value?: UpdateLegalEntityFinancialsCommandDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'revenue': value['revenue'],
        'employeesCount': value['employeesCount'],
        'fiscalYearEnd': value['fiscalYearEnd'],
    };
}

